export function formatDuration(seconds: number, locale: Intl.LocalesArgument) {

  const secondsWithOneDecimal = Math.round(seconds * 10) / 10;
  const fractionDigits = secondsWithOneDecimal < 10 ? 1 : 0;
  const roundedSeconds = fractionDigits > 0 ? secondsWithOneDecimal : Math.round(seconds);

  const hours = Math.floor(roundedSeconds / 3600);
  const minutes = Math.floor(roundedSeconds / 60) % 60;
  const remainingSeconds = (roundedSeconds % 60)
    .toLocaleString(
      locale,
      {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
      }
    );

  return [
    hours > 0 ? `${hours} h` : undefined,
    minutes > 0 || hours > 0 ? `${minutes} min` : undefined,
    `${remainingSeconds} s`
  ]
    .filter(segment => segment !== undefined)
    .join(" ");
}
